import { render } from "./StatisticsTableClique.vue?vue&type=template&id=196051f6&scoped=true&ts=true"
import script from "./StatisticsTableClique.vue?vue&type=script&lang=ts"
export * from "./StatisticsTableClique.vue?vue&type=script&lang=ts"

import "./StatisticsTableClique.vue?vue&type=style&index=0&id=196051f6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\arind\\Documents\\scm\\easynwk-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196051f6"]])

export default __exports__